// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatePaymentModal_overlay__JuOTW {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.CreatePaymentModal_modal__7O5Rz {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 360px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.CreatePaymentModal_modal__7O5Rz h3 {
  margin-bottom: 16px;
  text-align: center;
}

.CreatePaymentModal_field__Q6U9a {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.CreatePaymentModal_field__Q6U9a input,
.CreatePaymentModal_field__Q6U9a select {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
}

.CreatePaymentModal_actions__gwMEy {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.CreatePaymentModal_cancel__\\+B0GJ {
  background: #ccc;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}

.CreatePaymentModal_save__kYMgm {
  background: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PaymentMethods/CreatePaymentModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  width: 360px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.modal h3 {\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.field {\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.field input,\n.field select {\n  padding: 8px 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.cancel {\n  background: #ccc;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.save {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CreatePaymentModal_overlay__JuOTW`,
	"modal": `CreatePaymentModal_modal__7O5Rz`,
	"field": `CreatePaymentModal_field__Q6U9a`,
	"actions": `CreatePaymentModal_actions__gwMEy`,
	"cancel": `CreatePaymentModal_cancel__+B0GJ`,
	"save": `CreatePaymentModal_save__kYMgm`
};
export default ___CSS_LOADER_EXPORT___;
